(function () {
  document.querySelectorAll('[data-tm-related]').forEach(function (root) {
    var track = root.querySelector('[data-related-track]');
    var prev = root.querySelector('[data-related-prev]');
    var next = root.querySelector('[data-related-next]');
    if (!track || !prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
    }
    function step(dir) {
      var card = track.querySelector('.tm-related__card');
      var w = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
